import React from 'react';
import bgImage from '../../assets/servicesImages/ai/hero.png';
import card1 from '../../assets/servicesImages/ai/1.png';
import card2 from '../../assets/servicesImages/ai/2.png';
import card3 from '../../assets/servicesImages/ai/3.png';
import imagea from '../../assets/servicesImages/ai/a.png';
import Slider from 'react-slick';
import arrow from '../../assets/viewdetails.png';

const items = [
  {
    image: imagea,
    title: 'Sales & Purchase Management',
    desc: 'Expertise: Our team comprises experienced AI professionals with deep knowledge across various industries.'
  },
  {
    image: imagea,
    title: 'Sales & Purchase Management',
    desc: 'Increase Productivity & Lower Costs By Managing Your Sales & Purchased. It Manages complete cycle from Purchases to Sales Order.'
  },
  {
    image: imagea,
    title: 'Sales & Purchase Management',
    desc: 'Increase Productivity & Lower Costs By Managing Your Sales & Purchased. It Manages complete cycle from Purchases to Sales Order.'
  },
];

const settings = {
  className: 'center',
  centerMode: true,
  infinite: true,
  slidesToShow: 3,
  speed: 500,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2 },
    },
    {
      breakpoint: 640,
      settings: { slidesToShow: 1, centerMode: false },
    },
  ],
};

const cards = [
  {
    card: card1,
    title: 'AI Consulting',
    desc: 'Our AI Consulting experts analyze your operations, align with your business goals, pinpoint opportunities, and provide a seamless AI integration roadmap.'
  },
  {
    card: card2,
    title: 'AI Software Development',
    desc: 'We design and deploy end-to-end AI solutions that enhance automation, decision-making, and innovation.'
  },
  {
    card: card3,
    title: 'AI Data Architecture & Management',
    desc: 'Unlock the full potential of your data with optimized collection, management, prediction, and automation strategies.'
  },
];

const services = [
  {
    card: card1,
    title: 'AI Strategy & Consulting',
    desc: 'We create tailored strategies for AI adoption based on your current capabilities and business goals.'
  },
  {
    card: card2,
    title: 'Custom AI Solutions',
    desc: 'We build AI systems specifically designed to meet your unique business challenges.'
  },
  {
    card: card3,
    title: 'Machine Learning (ML) Services',
    desc: 'Train and deploy ML models that uncover patterns and support better decision-making.'
  },
  {
    card: card3,
    title: 'Natural Language Processing (NLP)',
    desc: 'Develop NLP solutions for text analysis, sentiment detection, and automation.'
  },
  {
    card: card3,
    title: 'Computer Vision',
    desc: 'Implement systems for object detection, image recognition, and video analysis.'
  },
  {
    card: card3,
    title: 'AI-Powered Automation',
    desc: 'Automate repetitive tasks and streamline workflows using AI technologies.'
  },
  {
    card: card3,
    title: 'AI Integration and Deployment',
    desc: 'Seamlessly integrate AI into existing systems with ongoing optimization support.'
  },
  {
    card: card3,
    title: 'Ethical AI and Governance',
    desc: 'Ensure your AI use is ethical, transparent, and in line with compliance frameworks.'
  },
];

const AI = () => {
  return (
    <div className="flex flex-col gap-16">
      {/* Hero Section */}
      <div
  className="w-full text-white flex justify-start items-center pt-24 relative bg-cover bg-center 
    sm:min-h-[400px] md:min-h-[500px] lg:min-h-[600px]"
  style={{ backgroundImage: `url(${bgImage})` }}
>


        <div className="absolute inset-0 bg-[rgba(89,119,221,0.3)] z-0"></div>
        <div className="flex flex-col gap-6 p-8 md:p-20 z-10 max-w-3xl">
          <h1 className="text-[20px] md:text-[40px] font-bold leading-tight">
            Artificial Intelligence Software Development
          </h1>
          <p className="text-[18px] md:text-[24px] lg:text-[20px]">
            AI software development transforms data into intelligence, automating tasks and driving innovation in various industries.
          </p>
        </div>
      </div>

      {/* Overview */}
      <div className="flex flex-col gap-6 px-4 md:px-20">
        <h2 className="text-center text-2xl md:text-3xl font-semibold">
          Artificial Intelligence Software Development
        </h2>
        <p className="text-sm md:text-base text-justify">
          With a human-centric approach and leveraging the power of AI, we focus on automating workflows, deploying advanced customer service chatbots, and offering predictive insights for strategic business decisions. This commitment ensures not just efficiency and cost savings, but also enriched experiences for customers and employees, shaping an AI-empowered future for your business that resonates with innovation and purpose.
        </p>
      </div>

      {/* Specialization */}
      <div className="flex flex-col gap-6 px-4 md:px-28">
        <h2 className="text-center text-2xl md:text-3xl font-semibold">Our Field of Specialization</h2>
        <p className="text-sm md:text-base text-justify">
          We provide a wide range of mobile app development services that benefit the businesses and organisations in which we collaborate. Our dedicated team of mobile app developers provides a variety of services to meet the various business needs.
        </p>
      </div>

      {/* Cards */}
      <div className="flex flex-wrap justify-center gap-6 px-4">
  {cards.map((c, i) => (
    <div
      key={i}
      className="group w-full sm:w-[300px] md:w-[350px] bg-white p-4 rounded-xl flex flex-col items-center gap-3 hover:scale-[1.03] hover:shadow-2xl transition-all duration-300"
    >
      <img
        src={c.card}
        alt="card"
        className="h-44 w-full object-cover rounded-md transition-transform duration-300 group-hover:scale-110"
      />
      <p className="font-bold text-lg text-center group-hover:text-blue-800 transition-colors duration-300">
        {c.title}
      </p>
      <p className="text-sm text-center">{c.desc}</p>
    </div>
  ))}
</div>


      {/* Services */}
      <h2 className="text-center text-2xl md:text-3xl font-semibold">Our AI Services</h2>
      <div className="flex flex-wrap justify-center gap-6 px-4">
        {services.map((s, i) => (
          <div
            key={i}
            className="w-full sm:w-[280px] md:w-[320px] bg-white shadow-md rounded-lg hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col"
          >
            <img src={s.card} alt="service" className="h-40 w-full object-cover" />
            <div className="p-4 flex flex-col gap-2 flex-grow">
              <p className="font-semibold text-sm text-center">{s.title}</p>
              <p className="text-sm text-justify">{s.desc}</p>
            </div>
            <div className="flex justify-center pb-3">
              <button className="bg-[#006BD3] hover:bg-[#0058AE] transition text-white rounded-full px-4 py-1 text-sm">
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Why Choose Us Section */}
      <div className="w-full bg-gradient-to-b from-[#f9f9f9] to-white py-12 px-4 md:px-10">
  <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
    Why Choose <span className="text-blue-600">Esparse Matrix Solutions?</span>
  </h2>

  <div className="flex flex-wrap justify-center gap-6">
    {items.map((item, i) => (
      <div
        key={i}
        className="w-full sm:w-[300px] md:w-[350px] lg:w-[300px] bg-gray-800 hover:shadow-xl transition-all duration-300 p-4 rounded-xl flex flex-col items-center gap-3"
      >
        <img
          src={item.image}
          alt="icon"
          className="h-44 w-full object-cover rounded-md"
        />
        <p className="font-bold text-lg text-center text-white">{item.title}</p>
        <p className="text-sm text-center text-gray-300">{item.desc}</p>
        <div className="mt-4 flex justify-center">
          <a
            href="/"
            className="text-[#0058AE] text-sm font-medium flex items-center gap-1 hover:underline"
          >
            View Details
            <img src={arrow} alt="arrow" className="w-3" />
          </a>
        </div>
      </div>
    ))}
  </div>
</div>


    </div>
  );
};

export default AI;
